import type { ReactNode } from 'react';
import type { ModalPanelProps } from './ModalPanel/ModalPanel';

import { Dialog } from '@headlessui/react';

import { getTestProps } from '../../lib/helpers';

import ModalPanel from './ModalPanel/ModalPanel';

interface ModalProps {
  /**
   * Is open state
   */
  open?: boolean;
  /**
   * Modal config
   */
  modalConfig?: ModalPanelProps;
  /**
   * Modals content
   */
  children?: ReactNode;
  /**
   * Component test id
   */
  testId?: string;
}

const Modal = ({
  open = true,
  modalConfig,
  children,
  testId = '',
}: ModalProps) => {
  return (
    <Dialog
      as="div"
      className="relative z-40 ease-out duration-250 data-closed:opacity-0"
      onClose={() => true}
      transition
      open={open}
      {...getTestProps(testId, 'overlay')}
    >
      {modalConfig && <ModalPanel {...modalConfig} />}
      {children}
    </Dialog>
  );
};

export default Modal;
